import {
  Component,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewContainerRef, Injector, ComponentFactoryResolver, ComponentRef,

} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CommandLineComponent } from '../../components/command-line/command-line';
import {CommandResolver} from "../../components/commands/command-resolver";
import {ListCommandsComponent} from "../../components/commands/list-commands/list-commands";
import {SimpleCommand} from "../../components/commands/command-parser";
import {CommandOutputComponent} from "../../components/command-output/command-output";
import {CommandActionBase, CommandActionInterface} from "../../components/commands/command-action";
import {ParticipantListCmdComponent} from "../../components/commands/participant-list-cmd/participant-list-cmd";
import {ParticipantDetailCmdComponent} from "../../components/commands/participant-detail-cmd/participant-detail-cmd";

import {DocumentListCmdComponent} from "../../components/commands/document-list-cmd/document-list-cmd";
import {DocumentDetailCmdComponent} from "../../components/commands/document-detail-cmd/document-detail-cmd";


declare var window;


@IonicPage()
@Component({
  selector: 'page-cli',
  templateUrl: 'cli.html',
  providers:[CommandLineComponent]
})

export class CliPage {



  public componentForAction={
    "ListCommandsAction":ListCommandsComponent,
    "ParticipantListCmdAction":ParticipantListCmdComponent,
    "DocumentListCmdAction":DocumentListCmdComponent,
    "DocumentDetailCmdAction":DocumentDetailCmdComponent,
    "CreateCmdAction":ParticipantDetailCmdComponent,
  };


  @ViewChild('terminal') terminalContainer:ElementRef;
  @ViewChild('outputContainer', ) outputContainer:ElementRef;
  @ViewChild('output', {read:ViewContainerRef}) output:ViewContainerRef;
  @ViewChild(CommandLineComponent) commandLine:CommandLineComponent;


  constructor(public elementRef:ElementRef,
              private componentFactoryResolver: ComponentFactoryResolver,
              private injector: Injector,
              // public commandLine:CommandLineComponent,
              public navCtrl: NavController,
              public commandResolver: CommandResolver,
              public navParams: NavParams,
              public renderer: Renderer2) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CliPage');
  }

  ionViewDidEnter(){

     console.log('ionViewDidEnter CliPage')
    this.executeCommand("create participant -username t1 -email t1@gmail.com");

  }

  ngAfterViewInit(){
    console.log('ngAfterViewInit CliPage')

  }

  private createOutputComponent(cmdObj: SimpleCommand, componentRef) {


    let outputRef = this.componentFactoryResolver.resolveComponentFactory(CommandOutputComponent)
      .create(this.injector);

    outputRef.instance.command = cmdObj.commandString;
    outputRef.instance.container.insert(componentRef.hostView);

    return outputRef;
  }


  addCommandResult(result){


    if(!this.componentForAction[result.commandAction.constructor.name])
    {
      console.error('no component found in cli.componentForAction for action', result.commandAction.constructor.name);
      return;
    }

    let componentForAction = this.componentForAction[result.commandAction.constructor.name];
    if(result.commandAction.constructor.name=="CreateCmdAction")
    {
      if(result.commandDetail === "participant")
        componentForAction = ParticipantDetailCmdComponent;
      else if(result.commandDetail==="document")
        componentForAction = DocumentDetailCmdComponent;
    }
    let actionComponentRef:ComponentRef<any> = this.componentFactoryResolver.resolveComponentFactory(componentForAction).create(this.injector);
    actionComponentRef.instance.setData(result.commandAction.getResult());

    let outputRef = this.componentFactoryResolver.resolveComponentFactory(CommandOutputComponent).create(this.injector);
    outputRef.instance.command = result.commandString;

    outputRef.instance.container.insert(actionComponentRef.hostView);
    this.output.insert(outputRef.hostView);

  }

  scrollToBottom(){
    // debugger;
    setTimeout(()=> {
      this.outputContainer.nativeElement.scroll({
        top: this.outputContainer.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
    },100);
  }



  public executeCommand(commandString){

    this.commandResolver.execute(commandString)
      .then( (result:any)=>{
        // debugger;
        if(this.commandLine) this.commandLine.clear();
        this.addCommandResult(result);
        this.scrollToBottom();


      })
      .catch((executeError)=>{
        if(executeError=="command not found"){
          this.commandLine.say("command not found, get the list of available commands with <span class='command'>?</span>", 3000)
        }

        //not necessary to clear the command line, display the error though, maybe try to highlight what was wrong.
        if(executeError.type==="user"){
          this.commandLine.say(executeError.message, 3000);
        }
        else{
          console.error(executeError);
        }
      });

  }

  commandIssued(event:any){
    this.executeCommand(event.detail);
    return false;

  }

}





// WEBPACK FOOTER //
// ./src/pages/cli/cli.ts